import React from 'react';

// CSS 애니메이션 스타일
const scaleInAnimation = `
  @keyframes scaleIn {
    0% {
      transform: scale(0.8);
      opacity: 0;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }
  
  .animate-scaleIn {
    animation: scaleIn 0.3s ease-out;
  }
`;

// 스타일 태그 추가
if (typeof document !== 'undefined' && !document.getElementById('approval-modal-styles')) {
  const style = document.createElement('style');
  style.id = 'approval-modal-styles';
  style.textContent = scaleInAnimation;
  document.head.appendChild(style);
}

interface ApprovalPendingModalProps {
  isOpen: boolean;
  onClose: () => void;
  message: string;
}

const ApprovalPendingModal: React.FC<ApprovalPendingModalProps> = ({ 
  isOpen, 
  onClose, 
  message 
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 transform animate-scaleIn">
        {/* 헤더 */}
        <div className="bg-gradient-to-r from-amber-500 to-orange-500 rounded-t-2xl p-6 text-center">
          <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
            <span className="text-2xl">⏳</span>
          </div>
          <h2 className="text-xl font-bold text-white">승인 대기 중</h2>
        </div>
        
        {/* 내용 */}
        <div className="p-6">
          <div className="text-center mb-6">
            <p className="text-gray-700 text-lg leading-relaxed">
              {message}
            </p>
            <p className="text-gray-500 text-sm mt-4">
              관리자 승인 후 다시 로그인해주세요.
            </p>
          </div>
          
          {/* 안내 메시지 */}
          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <span className="text-blue-500 text-lg">💡</span>
              </div>
              <div className="ml-3">
                <p className="text-blue-800 text-sm">
                  <strong>안내:</strong> 가입 신청 후 관리자가 승인하면 로그인할 수 있습니다.
                </p>
              </div>
            </div>
          </div>
          
          {/* 버튼 */}
          <button
            onClick={onClose}
            className="w-full bg-gradient-to-r from-slate-700 to-slate-800 hover:from-slate-800 hover:to-slate-900 text-white py-3 px-6 rounded-xl font-semibold transition-all transform hover:scale-105 shadow-lg"
          >
            확인
          </button>
        </div>
      </div>
    </div>
  );
};

export default ApprovalPendingModal;
